import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, saveToken } from '../lib/api';
import { useAuth } from '../lib/AuthContext';

export default function AuthCallback() {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) { navigate('/auth'); return; }
        const sessionId = match[1];
        (async () => {
            try {
                const res = await api.post('/auth/google', { session_id: sessionId });
                if (res.data?.session_token) saveToken(res.data.session_token);
                window.history.replaceState(null, '', window.location.pathname);
                await refresh();
                // go straight to app or pending session
                const pending = sessionStorage.getItem('pending_session');
                if (pending) {
                    sessionStorage.removeItem('pending_session');
                    try {
                        const data = JSON.parse(pending);
                        const res = await api.post('/chat/sessions', data);
                        navigate(`/app/samtale/${res.data.session.session_id}`, { replace: true });
                        return;
                    } catch {}
                }
                navigate('/app', { replace: true });
            } catch (e) {
                navigate('/auth?error=google', { replace: true });
            }
        })();
    }, [navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-bone">
            <div className="text-inkSoft text-sm">Logger deg inn…</div>
        </div>
    );
}
